import { render, staticRenderFns } from "./BillItemsComponent.vue?vue&type=template&id=47899490&scoped=true"
import script from "./BillItemsComponent.vue?vue&type=script&lang=js"
export * from "./BillItemsComponent.vue?vue&type=script&lang=js"
import style0 from "./BillItemsComponent.vue?vue&type=style&index=0&id=47899490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47899490",
  null
  
)

export default component.exports